
import React from 'react';
import { Editor } from '@tiptap/react';
import { Bold, Italic, Underline as UnderlineIcon, Strikethrough } from 'lucide-react';
import EditorButton from '../buttons/EditorButton';
import EditorButtonGroup from '../buttons/EditorButtonGroup';

interface FormatButtonsProps {
  editor: Editor;
}

const FormatButtons = ({ editor }: FormatButtonsProps) => {
  return (
    <EditorButtonGroup>
      <EditorButton 
        onClick={() => editor.chain().focus().toggleBold().run()}
        isActive={editor.isActive('bold')}
        title="Gras"
        icon={<Bold className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().toggleItalic().run()}
        isActive={editor.isActive('italic')}
        title="Italique"
        icon={<Italic className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        isActive={editor.isActive('underline')}
        title="Souligné"
        icon={<UnderlineIcon className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().toggleStrike().run()}
        isActive={editor.isActive('strike')}
        title="Barré"
        icon={<Strikethrough className="h-4 w-4" />}
      />
    </EditorButtonGroup>
  );
};

export default FormatButtons;
